import styled from 'styled-components';
import { Header } from '@leasequery/lq.react-component-library';

const StyledCategorySectionHeader = styled(Header)`
  border-bottom: 0.1rem solid
    ${(props): string => props.theme.colors.uhohYellow};
  padding: ${(props): string => props.theme.spaces.md} 0.8rem;
  margin-bottom: 0;
`;

export default StyledCategorySectionHeader;
